// TSS vite/04 §"Endpoint paths".
// Propuestas de donadora del cliente (public-donor-submissions.md, Q-122).

export const submissionPaths = {
    list:   () => 'public/donor-submissions',
    detail: (id) => `public/donor-submissions/${id}`,
    create: () => 'public/donor-submissions',
    update: (id) => `public/donor-submissions/${id}`,
    remove: (id) => `public/donor-submissions/${id}`,
};
